import InsightsOutlinedIcon from "@mui/icons-material/InsightsOutlined";

import { registerNavSection } from "./shell/navigation";

registerNavSection({ key: "reporting", spoke: "reporting", title: "Reporting", icon: InsightsOutlinedIcon, order: 61, entries: [
  { label: "Executive dashboard", to: "/app/reporting/dashboards/executive", permission: "reporting.dashboard.view" },
  { label: "Dashboards", to: "/app/reporting/dashboards", permission: "reporting.dashboard.view" },
  { label: "Exceptions", to: "/app/reporting/exceptions", permission: "reporting.dashboard.view" },
  { label: "Report catalog", to: "/app/reporting", permission: "reporting.report.view" },
  { label: "Runs & schedules", to: "/app/reporting/runs", permission: "reporting.report.view" },
  { label: "Cycle times", to: "/app/reporting/cycle-times", permission: "reporting.analytics.view" },
] });
